/* eslint-disable */
import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import {OutTable, ExcelRenderer} from 'react-excel-renderer'
import '../../../style/payment-base.css'
import SingleDatePicker from '../../BaseComponent/SingleDatePicker'
import http from '../../Interceptor/Interseptor'
import BASE_MANAGE from '../../BaseComponent/BASEMANAGE'
import USER_MANAGE from '../../BaseComponent/USERMANAGE'
import {message} from 'antd'
import './styleExcel.css'

class UploadExcell extends Component {
  constructor(props) {
    super(props)
    this.state = {
      cols: [],
      rows: [],
      dateValue: {
        from: 0,
        to: 0
      },
      fileObj: null,
      typeAccountId: '',
      fromTime: 0,
      toTime: 0,
      typeAccountIds: []
    }
  }

  handleChangeDate = (dateValue) => {
    this.setState({
      dateValue
    })
    //  let from = dateValue.from;
    //  let to = dateValue.to;
    //  this.setState({
    //      fromTime:from,
    //      toTime:to
    //  })
    // alert(dateValue)
    // this.setState({
    //     dateValue,
    // })
  }
  onUploadClick = () => {
    let fileObj = this.state.fileObj
    let fromTime = this.state.fromTime
    let toTime = this.state.toTime
    let dateValue = this.state.dateValue

    let typeAccountId = document.getElementById('typeAccountId').value

    if (fileObj === null || typeAccountId === '' || dateValue.from === 0 || dateValue.to === 0) {
      message.error('تمامی فیلد ها وارد شود')
    } else {
      const formData = new FormData()
      formData.append('file', fileObj)

      http
        .post(`${USER_MANAGE.USER_MANAGE_PAYMENT_TRANSACTION_REPORT_UPLOAD}`, formData, {
          params: {
            fromTime: dateValue.from,
            toTime: dateValue.to,
            typeAccountId
          }
        })
        .then((res) => {
          if (res.data.error === null) {
            message.success('بارگزاری با موفقیت انجام شد')
          } else {
            message.error(res.data.description)
          }
        })
        .catch((error) => {
          // alert(JSON.stringify(error))
        })
    }
  }
  componentDidMount() {
    http.get(`public/base/type/panel/has-terminal/accounts`, {}).then((res) => {
      if (res.data.error === null) {
        this.setState({
          typeAccountIds: res.data.object
        })
      }
    })
  }

  fileHandler = (event) => {
    let dailyFile = document.getElementById('daily-file').value
    if (dailyFile.includes('.xls') || dailyFile.includes('.xlsx')) {
      let fileObj = event.target.files[0]
      this.setState({
        fileObj
      })

      //just pass the fileObj as parameter
      ExcelRenderer(fileObj, (err, resp) => {
        if (err) {
          console.log(err)
        } else {
          console.log(resp)

          this.setState({
            cols: resp.cols,
            rows: resp.rows
          })
        }
      })
    } else {
      message.error('فرمت فایل انتخابی باید xls یا xlsx باشد')
    }
  }

  render() {
    return (
      <div className="rtl">
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>پرداخت</li>
            <li> بار گذاری</li>
          </ul>
          <div className="bg-white mt-3 py-3">
            <p className="text-danger text-center font-weight-bold font">
              کاربر گرامی، تمامی پایانه های موجود در فایل شما باید ابتدا در سیستم از طریق منوی{' '}
              <Link to={'/Base/payment/terminals'} target="_blank">
                پایانه ها
              </Link>{' '}
              درج شود
            </p>
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-4  mt-4">
                  <div>
                    <label className="mb-0" htmlFor="daily-file">
                      فایل را انتخاب کنید
                    </label>
                    <input
                      name="filer"
                      className="form-control"
                      id="daily-file"
                      type="file"
                      onChange={this.fileHandler.bind(this)}
                      style={{padding: '10px'}}
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div>
                    <SingleDatePicker dateLabel="تاریخ" setDate={this.handleChangeDate} />
                  </div>
                </div>
                <div className="col-lg-4 py-3">
                  <label>نوع پرداخت</label>
                  <select className="form-control" id="typeAccountId">
                    <option value="">------</option>
                    {this.state.typeAccountIds.map((item) => (
                      <option value={item.id}>{item.title}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12 text-center">
                  <button onClick={this.onUploadClick} className="mt-5 btn btn-info">
                    بارگزاری فایل
                  </button>
                </div>
              </div>

              <div className="row">
                <div className="col-12 mt-3">
                  <div className="">
                    <OutTable
                      data={this.state.rows}
                      columns={this.state.cols}
                      tableClassName="ExcelTable2007"
                      tableHeaderRowClass="heading"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default UploadExcell
